import style from "./Footer.module.css"

function Footer(props){

    return (
        <div className={"noPrint ".concat(style.footer)} style={props.style}>
            <span className={"noPrint"} style={{marginLeft:"1rem"}}>© Regione Veneto</span>
        </div>
    )


}
export default Footer
